import React from "react";
import { useTranslation } from "react-i18next";

interface BookingRulesProps {
  selectedDate: string;
  onChangeDate: () => void;
  onNext: () => void;
}

export const BookingRules: React.FC<BookingRulesProps> = ({
  selectedDate,
  onChangeDate,
  onNext,
}) => {
  const { t } = useTranslation("common");

  return (
    <div className="p-5 sm:p-6 space-y-5">
      {/* Selected Date Header Badge */}
      <div className="bg-amber-500/10 border border-amber-500/30 p-4 rounded-2xl flex justify-between items-center shadow-sm">
        <div>
          <span className="text-[10px] font-serif font-bold text-amber-700 dark:text-amber-400 uppercase tracking-widest">
            {t("booking.selectedDate", "Wybrana data")}
          </span>
          <p className="text-lg font-serif font-bold text-stone-900 dark:text-stone-100">
            {selectedDate}
          </p>
        </div>
        <button
          onClick={onChangeDate}
          className="text-xs font-serif text-amber-600 dark:text-amber-400 hover:underline font-semibold cursor-pointer"
        >
          {t("booking.changeDate", "Zmień datę")}
        </button>
      </div>

      {/* Rules Box */}
      <div className="max-h-56 overflow-y-auto text-xs font-serif text-stone-700 dark:text-stone-300 space-y-2.5 p-4 bg-white dark:bg-stone-900/60 rounded-2xl border border-stone-200 dark:border-stone-800 leading-relaxed custom-scrollbar">
        <p>
          {t(
            "booking.rules.rule1",
            "1. Złożenie rezerwacji nie jest jednoznaczne z jej potwierdzeniem. Oczekuj na wiadomość e-mail."
          )}
        </p>
        <p>
          {t(
            "booking.rules.rule2",
            "2. Stoliki są rezerwowane maksymalnie na 15 minut po planowanej godzinie."
          )}
        </p>
        <p>
          {t(
            "booking.rules.rule3",
            "3. Zapytania o stolik w strefie VIP realizujemy w zależności od dostępności."
          )}
        </p>
        <p>
          {t(
            "booking.rules.rule4_prefix",
            "4. W przypadku opóźnienia prosimy o kontakt: "
          )}
          <strong className="text-amber-700 dark:text-amber-400">
            +48 000 000 000
          </strong>
          .
        </p>
        <p>
          {t(
            "booking.rules.rule5_prefix",
            "5. Rezerwacje powyżej 8 osób prosimy kierować na adres: "
          )}
          <strong className="text-amber-700 dark:text-amber-400">
            admin@r-ja.pl
          </strong>
          .
        </p>
        <p>
          {t(
            "booking.rules.rule6",
            "6. Do rachunku doliczana jest opłata serwisowa 12,5% dla grup powyżej 6 osób."
          )}
        </p>
      </div>

      <button
        onClick={onNext}
        className="w-full py-4 bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-500 hover:to-amber-600 text-white font-serif text-xs font-semibold uppercase tracking-widest rounded-xl transition-all duration-200 shadow-lg shadow-amber-950/30 border border-amber-400/20 cursor-pointer"
      >
        {t("booking.next", "Dalej")}
      </button>
    </div>
  );
};
